import React from "react";
import {
  List,
  Datagrid,
  TextField,
  ShowButton,
  EditButton,
  ReferenceField,
} from "react-admin";
import ListPagination from "../../components/ListPagination";
import ConfirmBulkActions from "../../components/ConfirmBulkActions";
import { perPage } from "../../defaults/Defaults";

const AlertTypeList = (props) => {
  return (
    <List
      {...props}
      bulkActionButtons={<ConfirmBulkActions />}
      perPage={perPage}
      pagination={<ListPagination />}
      title="AlertTypes"
    >
      <Datagrid>
        <TextField source="event_type" />
      </Datagrid>
    </List>
  );
};

export default AlertTypeList;
